import React from "react";
import { useI18n } from "../i18n";
import { useMembership } from "../context/MembershipContext";
import { whatsappLink } from "../utils/support";

/**
 * One tap to the operator on WhatsApp, with the shop's name and link already in
 * the message so they know who is writing. Shows nothing until the operator has
 * set a number (platform settings), so it never points at nowhere.
 *
 * `variant="icon"` is the top bar's; `variant="full"` carries the words.
 */
export const useSupportLink = () => {
  const { t } = useI18n();
  const membership = useMembership();
  // Not rolled out to this shop yet: nothing to show
  if (membership && !membership.flag?.("support_tools")) return null;
  const number = membership?.support?.whatsapp_number;
  const shop = membership?.shop;

  return whatsappLink(number, t("support.whatsappMessage", { shop: shop?.name || "", slug: shop?.slug || "" }));
};

const SupportButton = ({ variant = "icon" }) => {
  const { t } = useI18n();
  const link = useSupportLink();

  if (!link) return null;

  if (variant === "full") {
    return (
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center justify-center gap-2 rounded-lg bg-green-600 px-4 py-3 font-semibold text-white hover:bg-green-700"
      >
        <span aria-hidden="true">💬</span>
        {t("support.whatsapp")}
      </a>
    );
  }

  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t("support.whatsapp")}
      title={t("support.whatsapp")}
      className="shrink-0 h-10 w-10 inline-flex items-center justify-center rounded-lg border border-green-600 bg-green-50 text-lg hover:bg-green-100 focus:outline-none focus:ring-2 focus:ring-green-500"
    >
      <span aria-hidden="true">💬</span>
    </a>
  );
};

export default SupportButton;
